import React from 'react';
import { createRoot } from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';
import { UIGame } from '@colonist/ui-game';
import { DialogManagerProvider } from '@colonist/ui';
import { clientI18n } from '../ClientI18n.ts';
import { createDivIn } from '../ui_utils/DomUtils.ts';
export const renderUIGame = (containerId, gameContainerPosition)=>{
    let container = document.getElementById(containerId);
    if (!container) {
        container = createDivIn(document.body, 'ui-game-container', containerId);
        container.style.left = gameContainerPosition.left + 'px';
        container.style.width = gameContainerPosition.width + 'px';
        container.style.height = gameContainerPosition.height + 'px';
    }
    const root = createRoot(container);
    return {
        render: (props)=>{
            root.render(/*#__PURE__*/ React.createElement(I18nextProvider, {
                i18n: clientI18n.instance
            }, /*#__PURE__*/ React.createElement(DialogManagerProvider, null, /*#__PURE__*/ React.createElement(UIGame, props))));
        },
        unmount: ()=>root.unmount()
    };
};
